module.exports = __webpack_public_path__ + "static/media/tutoriales_erp.07e59e37.svg";